import axios, { AxiosError } from "axios";
import { useMutation, UseMutationResult } from "react-query";
import { SegmentAssignmentPreviewRequest } from "../request/SegmentAssignmentPreviewRequest";
import { SegmentAssignmentPreviewResponse } from "../model/SegmentAssignmentPreviewResponse";

export const SegmentAssignmentPreviewApiService = async (
  request: SegmentAssignmentPreviewRequest
): Promise<SegmentAssignmentPreviewResponse> => {
  const { data } = await axios.post("/segment-assignments/preview/", request);
  return data;
};

const useSegmentAssignmentPreviewApiService = (): UseMutationResult<
  SegmentAssignmentPreviewResponse,
  AxiosError,
  SegmentAssignmentPreviewRequest
> =>
  useMutation<
    SegmentAssignmentPreviewResponse,
    AxiosError,
    SegmentAssignmentPreviewRequest
  >((request) => SegmentAssignmentPreviewApiService(request));

export default useSegmentAssignmentPreviewApiService;
